export function getImplicitHydrogensCount(molecule, atomID) {
    return molecule.getImplicitHydrogens(atomID);
}
//# sourceMappingURL=getImplicitHydrogensCount.js.map